import { useState } from 'react';
import { createPortal } from 'react-dom';
import s from './TrialModal.module.scss';

// ── 체험하기(SaaS 데모) 임시 계정 발급 폼 모달 (D안, 2026-09) ──────────
//   헤더 '체험하기' 클릭 → 이메일 입력 → '데모 접속 신청'. 방문자가 안전 통합관제 SaaS를
//   임시(게스트) 계정으로 체험. ★실제 발급/메일 발송(백엔드)은 후속 연결(Phase 3) — 지금은 폼+안내까지.
type Props = { open: boolean; onClose: () => void };

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function TrialModal({ open, onClose }: Props) {
  const [email, setEmail] = useState('');
  const [err, setErr] = useState('');
  const [sent, setSent] = useState(false);

  if (!open) return null;

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!EMAIL_RE.test(email.trim())) { setErr('올바른 이메일을 입력해 주세요.'); return; }
    setErr('');
    // TODO(Phase3): 백엔드 임시계정 발급 API 연결(POST). 지금은 접수 안내까지.
    setSent(true);
  };

  const close = () => { setSent(false); setEmail(''); setErr(''); onClose(); };

  return createPortal(
    <div className={s.overlay} data-lenis-prevent onMouseDown={close} role="dialog" aria-modal="true" aria-label="SaaS 데모 체험 신청">
      <div className={s.modal} onMouseDown={(e) => e.stopPropagation()}>
        <button className={s.close} onClick={close} aria-label="닫기">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round">
            <line x1="6" y1="6" x2="18" y2="18" /><line x1="18" y1="6" x2="6" y2="18" />
          </svg>
        </button>

        {!sent ? (
          <>
            <span className={s.eyebrow}>SaaS 데모 체험</span>
            <h2 className={s.title}>실제 관제 대시보드를<br />직접 체험해 보세요</h2>
            <p className={s.desc}>이메일을 남겨 주시면 <b>임시(게스트) 계정</b>으로 안전 통합관제 SaaS를 바로 둘러보실 수 있습니다. 가입 없이, 실제 데이터가 아닌 시연 환경으로 안전하게 체험됩니다.</p>
            <form className={s.form} onSubmit={submit} noValidate>
              <input
                type="email"
                className={s.input}
                placeholder="name@company.com"
                value={email}
                onChange={(e) => { setEmail(e.target.value); if (err) setErr(''); }}
                aria-invalid={!!err}
              />
              {err && <p className={s.err}>{err}</p>}
              <button type="submit" className={s.submit}>데모 접속 신청</button>
            </form>
            <p className={s.note}>* 시연 계정은 읽기 전용이라 데이터가 변경되지 않습니다.</p>
          </>
        ) : (
          <div className={s.done}>
            <div className={s.check}>
              <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <h2 className={s.title}>바로 접속할 수 있어요</h2>
            <p className={s.desc}>아래 버튼을 누르면 <b>시연 대시보드</b>에 게스트로 바로 접속됩니다. 별도 로그인·비밀번호 입력이 필요 없습니다. (읽기 전용)</p>
            {/* 자동로그인 URL(?demo=1). 대시보드 로그인 페이지가 이를 읽어 demo 계정으로 자동 로그인(Option A). 비번은 화면에 노출 안 함. */}
            <a className={s.submit} href="https://evstech-iot.com/?demo=1" target="_blank" rel="noopener noreferrer">
              SaaS 데모 열기 ↗
            </a>
          </div>
        )}
      </div>
    </div>,
    document.body,
  );
}
